module.exports = __webpack_public_path__ + "static/img/9.b199e526.jpg";